// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = module.exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-dialog__body {\n  padding: 0;\n}\n.hide .el-upload--picture-card {\n  display: none;\n}\n.el-form-item__content {\n  line-height: 40px !important;\n}\n", ""]);
